import axios from "axios";
import config from "./config";
export default {
    formatNumber(value, n = 2, x = 3, s = ".", c = ",") {
        let v;
        if (typeof value == "string") {
            v = Number(value);
        }
        else {
            v = value;
        }
        if (v == null)
            return "";
        const re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")", num = v.toFixed(Math.max(0, ~~n));
        return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
    },
    formatDatetime(date, time) {
        function zeroPad(d) {
            return ("0" + d).slice(-2);
        }
        var parsed = new Date(date);
        const reply = [
            parsed.getUTCFullYear(),
            "-",
            zeroPad(parsed.getMonth() + 1),
            "-",
            zeroPad(parsed.getDate()),
        ];
        if (time) {
            reply.push(" ");
            reply.push(zeroPad(parsed.getHours()));
            reply.push(":");
            reply.push(zeroPad(parsed.getMinutes()));
            reply.push(":");
            reply.push(zeroPad(parsed.getSeconds()));
        }
        return reply.join("");
    },
    async getPostalCodeInfo(postalCode) {
        try {
            let list = await axios.get(config.app_url == undefined
                ? ""
                : config.app_url + "utils/postal-code/" + postalCode, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return list.data;
        }
        catch (error) {
            return null;
        }
    },
};
